export function getComments(advertisementId: string) {
  return fetch(`/api/messages/${advertisementId}/comments`);
}

export function deleteComment(advertisementId: string, commentId: string) {
  return fetch(`/api/messages/${advertisementId}/comments/${commentId}`, {
    method: 'DELETE',
  });
}

export function postComment(advertisementId: string, payload: object) {
  const formData = new FormData();
  for (const [key, value] of Object.entries(payload)) {
    formData.append(key, value);
  }

  return fetch(`/api/messages/${advertisementId}/comments`, {
    body: formData,
    method: 'POST',
  });
}
